// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA9YWZRJd90TJcDxkrRoE2_RMkB7qrG9Ao",
    authDomain: "perkup-c11f8.firebaseapp.com",
    projectId: "perkup-c11f8",
    storageBucket: "perkup-c11f8.firebasestorage.app",
    messagingSenderId: "816184837279",
    appId: "1:816184837279:web:7f335332fb3c9e358a4eaa",
};

const app = initializeApp(firebaseConfig, "perkup"); // Her oyun için benzersiz bir isim
export const db2 = getFirestore(app);